import React from 'react';
import TabsCommonComponent, {
  ITabsData,
} from '../common/tabs-component/TabsCommonComponent';
import {t} from 'i18next';
import {Box, Typography} from '@mui/material';
import {useReviewHeaderContext} from '../header/ReviewHeader';
import {IssueCodeContentFallBack} from '../review-and-approve/review-and-approve-content/issue-codes-content/IssueCodesContent';

const ProtocolBody = () => {
  const {protocolDetails} = useReviewHeaderContext();

  const tabData: ITabsData[] = [
    {
      id: 1,
      label: t('ai.review.reviewAndApprove.caseContext'),
      content: (
        <Box>
          <Typography
            className="typo-text body3_size text-body-strong protocol-body-case-description-text"
            tabIndex={0}
            data-testid="protocol-body-case-description-text"
          >
            {protocolDetails?.caseContext}
          </Typography>
        </Box>
      ),
    },
    {
      id: 2,
      label: t('ai.review.reviewAndApprove.relevanceCriteria'),
      content: (
        <Typography
          className="typo-text body3_size text-headings protocol-body-case-description-text"
          tabIndex={0}
          data-testid="protocol-body-relevance-criteria"
        >
          {protocolDetails?.relevanceCriteria}
        </Typography>
      ),
    },
    {
      id: 3,
      label: t('ai.review.reviewAndApprove.issueCodes'),
      content: protocolDetails?.issueCodes?.length ? (
        <Box className="issue-codes-container">
          {protocolDetails?.issueCodes?.map((iCode, index) => (
            <Box key={iCode.code || index} className="issue-code-details">
              <Typography
                className="typo-text subhead5_size highlight-text-secondary"
                tabIndex={0}
                data-testid="protocol-body-issue-code"
              >
                {iCode.code}
              </Typography>

              <Typography
                className="typo-text body3_size text-body-strong"
                tabIndex={0}
                data-testid="protocol-body-issue-description"
              >
                {iCode.question}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <IssueCodeContentFallBack displayButton={false} />
      ),
    },
  ];

  return <TabsCommonComponent tabsData={tabData} />;
};

export default ProtocolBody;
